<template>
    <div class="fill-height map-basic">
        <div v-if="loading || loadingData" class="overlay secondary d-flex align-center justify-center">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </div>
        <GmapMap
                :key="$route.name"
                ref="map"
                :center="position"
                :options="{
                  draggableCursor: (actionType === 'circle' && !newCircleCenter.lat) || (actionType === 'polygon' && !polygonReady) ? 'crosshair': '',
                  clickableIcons: !['circle', 'polygon'].includes(actionType),
                  mapTypeId: 'roadmap'
                }"
                :zoom="zoom"
                map-type-id="terrain"
                style="width: 100%;height: 100%"
                @click="handleClickOnMap"
                @mousemove="getMovePoint"
                @zoom_changed="zoomChanged">
            <GmapMarker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :icon="getMarkerIcon(marker)"
                    :label="marker.FullName ? {
                     text: marker.FullName,
                    className:`font-weight-medium  ${marker.AlertID ? `alert alert-${marker.Severity.toLowerCase()}`: '' }`
                    }: null"
                    className="alert"
                    :position="marker"
                    @click="showMarkerDetails(marker)"/>
            <gmap-info-window
                    :opened="infoWinOpen"
                    :options="infoOptions"
                    :position="infoWindow"
                    @closeclick="infoWinOpen=false">
                <div class="body-2">
                    <div class="mb-2"><span class="font-weight-bold">{{ $t('authentication.name') }}:</span>
                        {{ infoWindow.FullName }}
                    </div>
                    <div class="mb-2"><span class="font-weight-bold">{{ $t('authentication.email') }}:</span>
                        {{ infoWindow.Email }}
                    </div>
                    <div class="mb-2"><span class="font-weight-bold">{{ $t('date') }}:</span>
                        {{ formatDateTime(infoWindow.CreatedAt) }}
                    </div>
                    <div class="mb-2"><span class="font-weight-bold">{{ $t('user.location') }}:</span> {{
                        infoWindow.lat
                        }},
                        {{ infoWindow.lng }}
                    </div>
                </div>
            </gmap-info-window>
            <gmap-polygon v-for="(polygon, index) in polygons" :key="index + 'polygon'" :editable="editPoints"
                          :options="{fillColor:  getColorByType(polygon.type) , fillOpacity : 0.35}"
                          :paths="polygon.points" :title="polygon.title"
                          @click="editZone(polygon.id)">
            </gmap-polygon>
            <gmap-circle v-for="(circle, index) in circles" :key="index + 'circle'" :center="circle"
                         :options="{fillColor:  getColorByType(circle.type) , fillOpacity : 0.35}"
                         :radius="circle.radius"
                         :title="circle.title" @click="editZone(circle.id)"/>
            <gmap-marker v-for="(circle, index) in circles" :key="index + 'circleLabel'"
                         :icon="shapeIcon" :label="{text: circle.title, fontSize: '16px'}" :position="circle"/>
            <gmap-marker v-for="(polygon, index) in polygonMarkers" :key="index + 'polygonLabel'"
                         :icon="shapeIcon" :label="{text: polygon.title, fontSize: '16px'}"
                         :position="polygon.position"/>
            <gmap-polygon :editable="editPoints"
                          :options="{fillColor: zoneColor.color, clickable: actionType !== 'polygon' , fillOpacity : 0.35}"
                          :paths="newPolygon"
                          draggable
                          @paths_changed="updateEdited($event)">
            </gmap-polygon>
            <gmap-circle v-if="newCircleCenter.lat"
                         :center="newCircleCenter"
                         :draggable="editPoints"
                         :editable="editPoints"
                         :options="{clickable: !setRadius, fillColor:  zoneColor.color , fillOpacity : 0.35}"
                         :radius="newCircleRadius"
                         @center_changed="dragendCircleCenter" @radius_changed="dragendCircleRadius"/>
            <div v-if="editPoints" ref="actions" class="edit-actions pa-2">
                <v-text-field v-model="zoneName" :label="$t('zones.zoneName')"></v-text-field>
                <div class="d-flex my-0">
                    <v-radio-group v-model="actionType" class="flex-row flex-nowrap" hide-details>
                        <v-tooltip
                                v-for="action in actions"
                                :key="action.id" bottom color="primary">
                            <template v-slot:activator="{ on }">
                                <v-radio
                                        :off-icon="action.icon"
                                        :on-icon="action.icon"
                                        :readonly="action.id === 'text'"
                                        :value="action.id"
                                        active-class="active"
                                        class="ma-1 action-type"
                                        hide-details
                                        @click="handleAction(action.id)"
                                        v-on="on"
                                ></v-radio>
                            </template>
                            <span class="secondary--text">{{ action.text }}</span>
                        </v-tooltip>
                    </v-radio-group>
                </div>
                <v-radio-group v-model="zoneColor" class="flex-row">
                    <v-tooltip v-for="zoneType in zoneTypes"
                               :key="zoneType.id" bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-radio
                                    :class="zoneType.colorClass"
                                    :value="zoneType"
                                    class="ma-1 action-type"
                                    color="white"
                                    hide-details
                                    off-icon=""
                                    on-icon="mdi-check"
                                    v-on="on">
                            </v-radio>
                        </template>
                        <span class="secondary--text">{{ zoneType.text }}</span>
                    </v-tooltip>
                </v-radio-group>
              {{zoneName}}
                <div class="d-flex justify-center">
                    <v-btn
                            :disabled="(!newCircleCenter.lat && !newPolygon.length && !zoneName)"
                            class="mx-2"
                            color="accent"
                            fab
                            small
                            @click="resetZone"
                    >
                        <v-icon color="accentText" dark>
                            mdi-restore
                        </v-icon>
                    </v-btn>
                    <v-btn
                            :disabled="(newPolygon.length<3 && !newCircleRadius) || !hasChanges || !zoneName"
                            class="mx-2"
                            color="success"
                            fab
                            small
                            @click="saveZone">
                        <v-icon>
                            mdi-check
                        </v-icon>
                    </v-btn>
                </div>
            </div>
        </GmapMap>
        <ConfirmDialog ref="deleteDialog" :accept-title="$t('reset')"
                       :popup-title="$t('zones.confirmReset')" :title="$t('zones.areYouSureRemoveCurrentShape')"/>
        <AlertDetails :key="alert.AlertID + 'map'"
                      :user-id="alert.OwnerID"
                      :alert="alert"
                      :alertID="alert.AlertID"
                      :open="openAlertDetails"
                      @close="openAlertDetails = false"/>
    </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps';
import {ZONE_TYPE_DANGER, ZONE_TYPE_SAFE, ZONE_TYPE_WARNING} from "@/helper/constants";
import {formatDateTime, isEqual} from "@/helper/helper";
import ConfirmDialog from "@/components/reusable/Dialog/ConfirmDialog";
import AlertDetails from "@/components/Alert/AlertDetails.vue";

export default {
  name: "MapBasic",
  components: {AlertDetails, ConfirmDialog},
  mounted() {
    this.loading = true;
    this.$refs.map.$mapPromise.then(map => {
      if (this.markers.length > 0) {
        this.setBounds = true;
        let bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.markers.length; i++) {

          let position = new window.google.maps.LatLng(this.markers[i].lat, this.markers[i].lng);
          bounds.extend(position);


        }
        map.fitBounds(bounds);
        this.loading = false;
      }

      if (this.circles.length || this.polygons.length) {
        this.setBounds = true;
        let bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.circles.length; i++) {
          let circle = new window.google.maps.Circle({
            center: new window.google.maps.LatLng(this.circles[i].lat, this.circles[i].lng),
            radius: this.circles[i].radius
          });

          let points = new window.google.maps.LatLng(circle.getBounds().getNorthEast().lat(), circle.getBounds().getNorthEast().lng());
          bounds.extend(points);

          points = new window.google.maps.LatLng(circle.getBounds().getSouthWest().lat(), circle.getBounds().getSouthWest().lng());
          bounds.extend(points);
        }
        let polygonMarkers = [];
        for (let i = 0; i < this.polygons.length; i++) {
          let polygonBounds = new window.google.maps.LatLngBounds();
          for (let j = 0; j < this.polygons[i].points.length; j++) {
            let position = new window.google.maps.LatLng(this.polygons[i].points[j].lat, this.polygons[i].points[j].lng);
            bounds.extend(position);
            polygonBounds.extend(position);
          }
          polygonMarkers.push({title: this.polygons[i].title, position: polygonBounds.getCenter()});
        }
        this.polygonMarkers = polygonMarkers;
        map.fitBounds(bounds);
        this.loading = false;

      }

      const centerControlDiv = this.$refs.actions;
      map.controls[window.google.maps.ControlPosition.RIGHT_TOP].push(
          centerControlDiv
      );

      if (this.zone && Object.keys(this.zone).length > 0) {
        this.zoneName = this.zone.Name;
        this.zoneColor = this.zoneTypes.filter((zone) => zone.id === this.zone.Type)[0];
        this.$refs.map.$mapPromise.then(map => {
          this.zoneNameChanged = false;
          let bounds = new window.google.maps.LatLngBounds();

          if (this.zone.Shape === 'Circle') {
            this.newCircleRadius = this.zone.Radius;
            this.oldCircleRadius = this.zone.Radius;
            this.newCircleCenter = {
              lat: this.zone.Points[0].Latitude,
              lng: this.zone.Points[0].Longitude
            };
            this.newUpdatedCircleCenter = {
              lat: this.zone.Points[0].Latitude,
              lng: this.zone.Points[0].Longitude
            };
            let circle = new window.google.maps.Circle({
              center: new window.google.maps.LatLng(this.newCircleCenter.lat, this.newCircleCenter.lng),
              radius: this.newCircleRadius
            });

            let points = new window.google.maps.LatLng(circle.getBounds().getNorthEast().lat(), circle.getBounds().getNorthEast().lng());
            bounds.extend(points);

            points = new window.google.maps.LatLng(circle.getBounds().getSouthWest().lat(), circle.getBounds().getSouthWest().lng());
            bounds.extend(points);
          } else {
            this.newPolygon = this.zone.Points.map((point) => ({
              lat: point.Latitude,
              lng: point.Longitude
            }));
            this.oldPolygon = [...this.newPolygon];
            for (let i = 0; i < this.newPolygon.length; i++) {
              let position = new window.google.maps.LatLng(this.newPolygon[i].lat, this.newPolygon[i].lng);
              bounds.extend(position);
            }
          }
          map.fitBounds(bounds);
          this.setBounds = true;
          this.loading = false;
        });
      }
      if (this.markers.length === 1 && !this.circles.length && !this.polygons.length) {
        setTimeout(() => {
          map.setZoom(map.getZoom() - 5);
        }, 100);
      }
      if (!this.markers.length && !this.circles.length && !this.polygons.length) {
        navigator.geolocation.getCurrentPosition((position) => {
          setTimeout(() => {
            if (!this.setBounds) {
              this.position = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.loading = false;
            }

          }, 1000);
        }, () => {
          this.loading = false;
        });
        setTimeout(() => {
          this.loading = false;
        }, 3000);
      }
    });

    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  props: {
    beforeLeave: {
      type: Boolean,
      required: false,
      default: false,
    },
    markers: {
      type: Array,
      required: false,
      default: () => [],
    },
    polygons: {
      type: Array,
      required: false,
      default: () => [],
    },
    circles: {
      type: Array,
      required: false,
      default: () => [],
    },
    editPoints: {
      type: Boolean,
      required: false,
      default: false,
    },
    zone: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    loadingData: {
      type: Boolean,
      required: false,
      default: false,
    },
    refreshCenterCount: {
      type: Number,
      required: false,
      default: 0,
    },
    clickFullScreen: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableBackNavigation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      alert: {},
      openAlertDetails: false,
      zoneColor: {
        id: 'Normal',
        text: this.$t("zones.normal"),
        color: this.$vuetify.theme.currentTheme.primary,
        colorClass: 'primary'
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      confirmDialog: false,
      infoWinOpen: false,
      infoWindow: {
        lat: 45.943161,
        lng: 24.96676,
      },
      position: {
        lat: 51.5072,
        lng: 0.1276,
      },
      zoom: 14,
      newPolygon: [],
      oldPolygon: [],
      newCircleCenter: {
        lat: 0,
        lng: 0
      },
      newUpdatedCircleCenter: {
        lat: 0,
        lng: 0
      },
      movingPoint: {
        lat: 0,
        lng: 0
      },
      zoneName: '',
      newCircleRadius: 0,
      oldCircleRadius: 0,
      setRadius: false,
      actionType: 'pointer',
      polygonReady: false,
      mouseClick: false,
      loading: true,
      setBounds: false,
      polygonMarkers: [],
      saveLoading: false,
      polygonChanged: false,
      zoneNameChanged: false,
    };
  },
  computed: {
    google: gmapApi,
    hasChanges() {
      if ((!this.zone || !Object.keys(this.zone).length) && !this.zoneName && !this.polygonChanged && !this.newCircleRadius) {
        return false;
      }
      return this.polygonChanged || this.zoneNameChanged || this.newCircleCenter.lat !== this.newUpdatedCircleCenter.lat || this.newCircleCenter.lng !== this.newUpdatedCircleCenter.lng || this.oldCircleRadius !== this.newCircleRadius || this.zone.Type !== this.zoneColor.id;
    },
    zoneActualName() {
      return this.zoneName;
    },
    polygonPath() {
      if (!this.movingPoint.lat) {
        return this.newPolygon;
      }
      return [...this.newPolygon, this.movingPoint];
    },
    zoneTypes() {
      return [
        {
          id: 'Normal',
          text: this.$t("zones.normal"),
          color: this.$vuetify.theme.currentTheme.primary,
          colorClass: 'primary'
        },
        {
          id: 'Safe',
          text: this.$t("zones.safe"),
          color: this.$vuetify.theme.currentTheme.success,
          colorClass: 'success'
        },
        {
          id: 'Warning',
          text: this.$t("notifications.warning"),
          color: this.$vuetify.theme.currentTheme.warning,
          colorClass: 'warning'
        },
        {
          id: 'Danger',
          text: this.$t("zones.danger"),
          color: this.$vuetify.theme.currentTheme.error,
          colorClass: 'error'
        },
      ];
    },
    shapeIcon() {
      return {
        path: window.google.maps.SymbolPath.CIRCLE, scale: 0,
        labelOrigin: {x: 17.5, y: 45},
        labelSize: 18,
        shadowSize: 10,
      };
    },
    actions() {
      return [
        {
          id: 'pointer',
          text: this.$t("zones.drag"),
          icon: 'mdi-hand-back-right-outline',
        },
        {
          id: 'circle',
          text: this.$t("zones.circle"),
          icon: 'mdi-circle-outline',
        },
        {
          id: 'polygon',
          text: this.$t("zones.polygon"),
          icon: 'mdi-vector-polygon ',
        },
        {
          id: 'text',
          text: this.$t("zones.editName"),
          icon: 'mdi-format-text',
        },
      ];
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
  },
  watch: {
    hasChanges() {
      this.$emit('hasChanges', this.hasChanges);
    },
    zoneName() {
      this.zoneNameChanged = true;
    },
    markers() {
      this.calculateCenter();
    },
    refreshCenterCount() {
      this.calculateCenter();
    },
    polygons() {
      if (this.polygons.length + this.circles.length !== 1) {
        this.calculateCenter();
      }
    },
    circles() {
      if (this.polygons.length + this.circles.length !== 1) {
        this.calculateCenter();
      }
    },
    actionType(type, oldType) {
      this.$refs.map.$mapPromise.then(map => {
        map.setZoom(map.getZoom() + 1);
        map.setZoom(map.getZoom() - 1);
      });

      if (type === 'circle' && this.newPolygon.length) {
        this.confirmDialog = true;
        this.$refs.deleteDialog.openDialog().then((res) => {
          if (res) {
            this.newPolygon = [];
            this.polygonReady = false;
            this.movingPoint = {lat: 0, lng: 0};
          } else {
            this.actionType = oldType;
          }
        }).finally(() => {
          this.confirmDialog = false;
        });
      } else if (type === 'polygon' && this.newCircleRadius) {
        this.confirmDialog = true;
        this.$refs.deleteDialog.openDialog().then((res) => {
          if (res) {
            this.newCircleRadius = 0;
            this.newCircleCenter = {lat: 0, lng: 0};
          } else {
            this.actionType = oldType;
          }
        }).finally(() => {
          this.confirmDialog = false;
        });
      }
    },
    zone: {
      handler(zone) {
        if (zone) {
          this.polygonChanged = false;
          this.zoneName = this.zone.Name;
          this.zoneColor = this.zoneTypes.filter((zoneType) => zoneType.id === zone.Type)[0];
          this.$refs.map.$mapPromise.then(map => {
            this.zoneNameChanged = false;
            this.setBounds = true;
            let bounds = new window.google.maps.LatLngBounds();

            if (zone.Shape === 'Circle') {
              this.newCircleRadius = zone.Radius;
              this.oldCircleRadius = zone.Radius;
              this.newCircleCenter = {
                lat: zone.Points[0].Latitude,
                lng: zone.Points[0].Longitude
              };
              this.newUpdatedCircleCenter = {
                lat: zone.Points[0].Latitude,
                lng: zone.Points[0].Longitude
              };
              let circle = new window.google.maps.Circle({
                center: new window.google.maps.LatLng(this.newCircleCenter.lat, this.newCircleCenter.lng),
                radius: this.newCircleRadius
              });

              let points = new window.google.maps.LatLng(circle.getBounds().getNorthEast().lat(), circle.getBounds().getNorthEast().lng());
              bounds.extend(points);

              points = new window.google.maps.LatLng(circle.getBounds().getSouthWest().lat(), circle.getBounds().getSouthWest().lng());
              bounds.extend(points);
            } else {
              this.newCircleRadius = 0;
              this.oldCircleRadius = 0;
              this.newCircleCenter = {
                lat: 0,
                lng: 0
              };
              this.newUpdatedCircleCenter = {
                lat: 0,
                lng: 0
              };
              this.newPolygon = zone.Points.map((point) => ({
                lat: point.Latitude,
                lng: point.Longitude
              }));
              this.oldPolygon = [...this.newPolygon];
              for (let i = 0; i < this.newPolygon.length; i++) {
                let position = new window.google.maps.LatLng(this.newPolygon[i].lat, this.newPolygon[i].lng);
                bounds.extend(position);
              }
            }

            map.fitBounds(bounds);
            this.loading = false;
          });
        }
      },
      deep: true
    },

  },
  methods: {
    isEqual,
    formatDateTime,
    calculateCenter() {
      this.$refs.map.$mapPromise.then(map => {
        let bounds = new window.google.maps.LatLngBounds();
        if (this.markers.length > 0) {
          this.setBounds = true;
          let closeInfoWin = true;
          for (let i = 0; i < this.markers.length; i++) {
            let position = new window.google.maps.LatLng(this.markers[i].lat, this.markers[i].lng);
            if (this.infoWindow.lat === this.markers[i].lat && this.infoWindow.lng === this.markers[i].lng) {
              closeInfoWin = false;
            }
            bounds.extend(position);
          }
          if (closeInfoWin) {
            this.infoWinOpen = false;
          }
        } else {
          this.infoWinOpen = false;
        }

        if (this.circles.length || this.polygons.length) {
          this.setBounds = true;
          for (let i = 0; i < this.circles.length; i++) {
            let circle = new window.google.maps.Circle({
              center: new window.google.maps.LatLng(this.circles[i].lat, this.circles[i].lng),
              radius: this.circles[i].radius
            });

            let points = new window.google.maps.LatLng(circle.getBounds().getNorthEast().lat(), circle.getBounds().getNorthEast().lng());
            bounds.extend(points);

            points = new window.google.maps.LatLng(circle.getBounds().getSouthWest().lat(), circle.getBounds().getSouthWest().lng());
            bounds.extend(points);
          }
          let polygonMarkers = [];
          for (let i = 0; i < this.polygons.length; i++) {
            let polygonBounds = new window.google.maps.LatLngBounds();
            for (let j = 0; j < this.polygons[i].points.length; j++) {
              let position = new window.google.maps.LatLng(this.polygons[i].points[j].lat, this.polygons[i].points[j].lng);
              bounds.extend(position);
              polygonBounds.extend(position);
            }
            polygonMarkers.push({title: this.polygons[i].title, position: polygonBounds.getCenter()});
          }
          this.polygonMarkers = polygonMarkers;

        }
        if (this.markers.length || this.polygons.length || this.circles.length) {
          setTimeout(() => {
            map.fitBounds(bounds);
            this.loading = false;
            if (this.markers.length === 1 && !this.polygons.length && !this.circles.length) {
              map.setZoom(map.getZoom() - 5);
            }
          }, 50);
        }

        if (!this.polygons.length) {
          this.polygonMarkers = [];
        }

      });
    },
    getMarkerIcon(marker) {
      if (!marker.AvatarUrl) {
        return null;
      }
      return {
        url: marker.AvatarUrl + '?roundImg=true',
        scaledSize: {width: 35, height: 35},
        labelOrigin: {x: 17.5, y: 45},
        shadowSize: 10,
      };
    },
    handleClickOnMap(e) {
      this.mouseClick = true;
      this.infoWinOpen = false;

      this.$refs.map.$mapPromise.then(map => {
        const isFullScreen = (document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement) === map.getDiv().firstChild;

        if (!isFullScreen && this.clickFullScreen) {
          document.getElementsByClassName('gm-fullscreen-control')[0].click();
        }
      });


      if (this.actionType === 'circle') {
        if (this.setRadius) {
          this.setRadius = false;
        } else {
          this.newCircleRadius = 0;
          this.newCircleCenter = {
            lat: parseFloat(e.latLng.lat().toFixed(7)),
            lng: parseFloat(e.latLng.lng().toFixed(7))
          };
          this.setRadius = true;
        }
      } else if (this.actionType === 'polygon' && !this.polygonReady) {
        if (this.newPolygon.length) {
          this.polygonChanged = true;
          const d = this.getPointDistancePixel(this.newPolygon[0], {
            lat: parseFloat(e.latLng.lat().toFixed(7)),
            lng: parseFloat(e.latLng.lng().toFixed(7))
          });
          if (d < 20) {
            this.polygonReady = true;
            return;
          }
        }
        this.newPolygon.push({
          lat: parseFloat(e.latLng.lat().toFixed(7)),
          lng: parseFloat(e.latLng.lng().toFixed(7))
        });


      }

      this.mouseClick = false;
      /**/

    },
    getMovePoint(e) {
      if (this.mouseClick) {
        return;
      }

      if (this.actionType === 'circle' && this.setRadius) {
        const d = this.getPointsDistance(this.newCircleCenter, {
          lat: parseFloat(e.latLng.lat().toFixed(7)),
          lng: parseFloat(e.latLng.lng().toFixed(7))
        });
        this.newCircleRadius = d;
      }
      if (this.actionType === 'polygon') {

        if (this.newPolygon.length) {
          const d = this.getPointDistancePixel(this.newPolygon[0], {
            lat: parseFloat(e.latLng.lat().toFixed(7)),
            lng: parseFloat(e.latLng.lng().toFixed(7))
          });

          if (d < 20) {
            this.movingPoint = this.newPolygon[0];
          } else {
            this.movingPoint = {
              lat: parseFloat(e.latLng.lat().toFixed(7)),
              lng: parseFloat(e.latLng.lng().toFixed(7))
            };
          }
        }
      }
    },
    getPointsDistance(pointA, pointB) {
      const R = 6371e3; // metres
      const φ1 = pointA.lat * Math.PI / 180; // φ, λ in radians
      const φ2 = pointB.lat * Math.PI / 180;
      const Δφ = (pointB.lat - pointA.lat) * Math.PI / 180;
      const Δλ = (pointB.lng - pointA.lng) * Math.PI / 180;

      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
          Math.cos(φ1) * Math.cos(φ2) *
          Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c; // in metres
    },
    getPointDistancePixel(p1, p2) {
      const pixelSize = Math.pow(2, -this.zoom);
      return Math.sqrt((p1.lat - p2.lat) * (p1.lat - p2.lat) + (p1.lng - p2.lng) * (p1.lng - p2.lng)) / pixelSize;

    },
    dragendCircleCenter(e) {
      this.newUpdatedCircleCenter = {lat: (e.lat()), lng: (e.lng())};
    },
    dragendCircleRadius(radius) {
      this.newCircleRadius = radius;
    },
    clickPolyline(e) {
      if (e.vertex === 0) {
        this.polygonReady = true;
        //   this.newPolygon.push({lat: parseFloat(e.latLng.lat().toFixed(7)),lng:parseFloat(e.latLng.lng().toFixed(7))})
      } else {
        this.newPolygon.push({lat: parseFloat(e.latLng.lat().toFixed(7)), lng: parseFloat(e.latLng.lng().toFixed(7))});
      }
    },
    zoomChanged(zoom) {
      this.zoom = zoom;
    },
    handleDblClick(e) {
      e.stop();
      if (this.actionType === 'polygon') {

        this.polygonReady = true;
      }
    },
    getColorByType(type) {
      switch (type) {
        case ZONE_TYPE_SAFE:
          return this.$vuetify.theme.currentTheme.success;
        case ZONE_TYPE_WARNING:
          return this.$vuetify.theme.currentTheme.warning;
        case ZONE_TYPE_DANGER:
          return this.$vuetify.theme.currentTheme.error;
        default:
          return this.$vuetify.theme.currentTheme.primary;
      }
    },
    handleAction(action) {
      if (action === 'text') {
        this.$emit('editText');
      }
    },
    saveZone() {
      let newZone = {};
      if (this.newCircleRadius) {
        newZone = {
          Name: this.zoneName,
          Type: this.zoneColor.id,
          Shape: 'Circle',
          Radius: this.newCircleRadius,
          Points: [{
            Latitude: this.newUpdatedCircleCenter.lat ? this.newUpdatedCircleCenter.lat : this.newCircleCenter.lat,
            Longitude: this.newUpdatedCircleCenter.lng ? this.newUpdatedCircleCenter.lng : this.newCircleCenter.lng
          }]
        };
      } else {
        newZone = {
          Name: this.zoneName,
          Type: this.zoneColor.id,
          Shape: 'Polygon',
          Radius: 0,
          Points: this.newPolygon.map(point => ({Latitude: point.lat, Longitude: point.lng}))
        };
      }
      this.$emit('saveZone', newZone);
    },
    resetZone() {
      this.$refs.deleteDialog.openDialog().then((res) => {
        if (res) {
          this.newPolygon = [];
          this.polygonReady = false;
          this.movingPoint = {lat: 0, lng: 0};
          this.newCircleRadius = 0;
          this.newCircleCenter = {lat: 0, lng: 0};
          this.zoneName = '';
        }
      });
    },
    editZone(id) {
      if (this.isAdmin) {
        this.$router.push({name: 'editZone', params: {id: parseInt(id)}});
      }
    },
    handleKeyup(e) {
      if (this.confirmDialog || this.beforeLeave) {
        return;
      }
      if (e.key === 'Enter') {
        if (!(this.newPolygon.length < 3 && !this.newCircleRadius) && !this.loading) {
          this.saveZone();
        }
      } else if (e.key === 'Escape' && !this.disableBackNavigation) {
        this.$router.back();
      }
    },
    showMarkerDetails(marker) {
      if (marker.AlertID) {
        this.alert = marker;
        this.openAlertDetails = true;
      } else {
        this.infoWindow = {...marker};
        this.infoWinOpen = true;
      }

    },
    updateEdited(mvcArray) {

      let path = [];
      for (let j = 0; j < mvcArray.getAt(0).getLength(); j++) {
        let point = mvcArray.getAt(0).getAt(j);
        path.push({lat: point.lat(), lng: point.lng()});
      }
      this.newPolygon = path;
      this.polygonChanged = true;
    }
  },

};
</script>

<style lang="scss" scoped>
@import "map-basic";
</style>